import React, {useState} from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import sAction from 'sAction';
import Select from '../../formElements/Select';
import Button from '../../formElements/Button';

export default function ChooseModelPopup(props) {
    const module = props.data.get('params').get('module');

    const [recordId, setRecordId] = useState(null);

    const clickHandler = () => {
        sAction.load();
        sAction.rest.fetchData('chooseModel', 'POST', {recordId}).then((returnData) => {
            sAction.route();
            sAction.popupHide();
            sAction.unLoad();
        }).catch((errorData) => {
            sAction.error(errorData?.text);
            sAction.unLoad();
        });
    };

    return (
        <React.Fragment>
            <div className='acmPopupContent'>
                {sAction.translate('LBL_CHOOSE_MODEL_DESCRIPTION', module)}
            </div>
            <div className='acmPopupButtons'>
                <Select
                    key={'MassAssignVATPopupFormSelect'}
                    className="acmSelectContainer"
                    options={props.data.get('params').get('opt').toJS()}
                    onChange={(e) => setRecordId(e.target.value)}
                />
                <Button className="hoverBlue" onClick={clickHandler}>
                    <div className="icon-duplicateIcon" />
                    {sAction.translate('LBL_CHOOSE_MODEL_PROCEED', module)}
                </Button>
                <Button className="hoverBlue" onClick={() => sAction.popupHide()}>
                    <div className="icon-undo" />
                    {sAction.translate('LBL_CANCEL', module)}
                </Button>
            </div>
        </React.Fragment>
    );
}

ChooseModelPopup.propTypes = {
    data: ImmutablePropTypes.mapContains({
        params: ImmutablePropTypes.mapContains({
            module: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
};
